// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-movers-tbl-container {
  width: 100%;
}

.top-movers-tbl {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.top-movers-tbl-hdr-row {
  height: 32px;
  border-bottom: 1px solid var(--border-line);
}

.top-movers-tbl-cell-row {
  height: 40px;
  background-color: var(--row-light);
}

.top-movers-tbl-cell-row:nth-child(2n) {
  background-color: var(--row-dark);
}

.top-movers-tbl thead th:last-child,
.top-movers-tbl tbody td:last-child {
  padding-right: 8px;
}

.top-movers-tbl-cell {
  box-sizing: border-box;
  vertical-align: middle;
}

.top-movers-tbl-hdr-row th {
  box-sizing: border-box;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
  align-content: start;
}

.top-movers-tbl-hdr-price,
.top-movers-tbl-hdr-nct,
.top-movers-tbl-hdr-pct,
.top-movers-tbl-hdr-volume,
.top-movers-tbl-hdr-turnover {
  text-align: right;
}

.top-movers-tbl-hdr-ticker,
.top-movers-tbl-hdr-name,
.top-movers-tbl-cell-ticker,
.top-movers-tbl-cell-name {
  padding-left: 0px;
  padding-right: 8px;
}

/* Index */
.top-movers-tbl-hdr-idx,
.top-movers-tbl-cell-idx {
  width: 65px;
  padding-left: 8px;
  text-align: center;
}

.top-movers-tbl-cell-idx {
  padding: 5px 0px 5px 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-subheader);
}

/* Ticker */
.top-movers-tbl-hdr-ticker,
.top-movers-tbl-cell-ticker {
  width: 80px;
  white-space: nowrap;
  text-align: left;
}

.top-movers-tbl-hdr-today,
.top-movers-tbl-cell-today {
  display: none;
}

.top-movers-tbl-cell-today-container {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 34px;
}

.top-movers-tbl-cell-today img {
  height: 100%;
  width: 100%;
}

/* Name */
.top-movers-tbl-hdr-name,
.rec-tbl-cell-name {
  text-align: left;
  white-space: nowrap;
}

/* Ticker text style — applied whether or not the code is clickable */
.top-movers-tbl-ticker {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  vertical-align: middle;
  color: var(--text-ticker);
}

/* Only when onCallback is provided */
.top-movers-tbl-ticker-link {
  cursor: pointer;
}

.top-movers-tbl-name {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  vertical-align: middle;
  color: var(--text-instrument);
}

.top-movers-tbl-cell-name {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: left;
}

.top-movers-tbl-cell-name-container {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.top-movers-tbl-hdr-price,
.top-movers-tbl-hdr-nct,
.top-movers-tbl-cell-price,
.top-movers-tbl-cell-nct {
  white-space: nowrap;
  padding-right: 0px;
}

.top-movers-tbl-cell-price,
.top-movers-tbl-cell-nct {
  padding: 7px 0px 7px 16px;
}

.top-movers-tbl-hdr-pct,
.top-movers-tbl-cell-pct {
  width: 25%;
  padding-right: 8px;
  text-align: right;
}

.top-movers-tbl-cell-pct {
  padding: 7px 8px 7px 16px;
}

.top-movers-tbl-cell-price {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: var(--text-primary);
}

.top-movers-tbl-cell-nct,
.top-movers-tbl-cell-pct {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: var(--text-unchg-color);
}

.top-movers-tbl-cell-nct.positive,
.top-movers-tbl-cell-pct.positive {
  color: var(--text-up-color);
}

.top-movers-tbl-cell-nct.negative,
.top-movers-tbl-cell-pct.negative {
  color: var(--text-down-color);
}

.top-movers-tbl-cell-volume {
  padding: 5px 0px 5px 16px;
}

.top-movers-tbl-hdr-volume,
.top-movers-tbl-cell-volume,
.top-movers-tbl-hdr-turnover,
.top-movers-tbl-cell-turnover {
  text-align: right;
  font-size: 16px;
  white-space: nowrap;
  color: var(--text-primary);
}

.top-movers-tbl-hdr-code-name {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #1e1f2f;
  text-align: left;
  white-space: nowrap;
}

.top-movers-tbl-cell-code-name {
  padding: 5px 16px 5px 0px;
  vertical-align: middle;
}

.top-movers-tbl-cell.top-movers-tbl-cell-code-name {
  padding-left: 8px;
}

.top-movers-tbl-code-name-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.top-movers-tbl-code-row,
.top-movers-tbl-company-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.top-movers-tbl-flag-placeholder {
  width: 16px;
}

.top-movers-tbl-company-name {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1e1f2f;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.top-movers-table-spacer {
  height: 8px;
}

@container (min-width: 768px) {
  .top-movers-tbl thead th:last-child,
  .top-movers-tbl tbody td:last-child {
    padding-right: 0px;
  }
  .top-movers-tbl-hdr-today,
  .top-movers-tbl-cell-today {
    display: table-cell;
    padding-left: 12px;
  }

  .top-movers-tbl-hdr-name,
  .top-movers-tbl-cell-name {
    width: 25%;
  }

  .top-movers-tbl-hdr-idx {
    padding-right: 16px;
    padding-left: 20px;
  }

  .top-movers-tbl-hdr-ticker,
  .top-movers-tbl-cell-ticker,
  .top-movers-tbl-hdr-name,
  .top-movers-tbl-cell-name {
    padding-left: 16px;
  }

  .top-movers-tbl-hdr-nct,
  .top-movers-tbl-cell-nct,
  .top-movers-tbl-hdr-pct,
  .top-movers-tbl-cell-pct {
    width: 10%;
    padding-right: 0px;
  }
  .top-movers-tbl tbody td.top-movers-tbl-cell-volume {
    width: 15%;
    padding-right: 12px;
  }
  .top-movers-tbl thead th.top-movers-tbl-hdr-volume {
    width: 15%;
    padding-right: 12px;
  }
}

@container (min-width: 1024px) {
  .top-movers-tbl-hdr-ticker,
  .top-movers-tbl-hdr-name {
    padding-left: 16px;
  }
  .top-movers-tbl-hdr-idx {
    padding-left: 24px;
  }
  .top-movers-tbl thead th.top-movers-tbl-hdr-turnover,
  .top-movers-tbl tbody td.top-movers-tbl-cell-turnover {
    padding-right: 16px;
  }

  .top-movers-tbl-hdr-nct,
  .top-movers-tbl-cell-nct,
  .top-movers-tbl-hdr-pct,
  .top-movers-tbl-cell-pct {
    width: unset;
  }

  .top-movers-tbl thead th.top-movers-tbl-hdr-volume,
  .top-movers-tbl tbody td.top-movers-tbl-cell-volume,
  .top-movers-tbl thead th.top-movers-tbl-hdr-turnover,
  .top-movers-tbl tbody td.top-movers-tbl-cell-turnover {
    width: 14%;
  }

  .top-movers-tbl thead th.top-movers-tbl-hdr-volume,
  .top-movers-tbl tbody td.top-movers-tbl-cell-volume {
    padding-right: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/TopMoversTable/TopMoversTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,UAAU;AACV;;EAEE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,SAAS;AACT;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;IAEE,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;;;;IAIE,kBAAkB;EACpB;;EAEA;;;;IAIE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;EACrB;;EAEA;;;;IAIE,YAAY;EACd;;EAEA;;;;IAIE,UAAU;EACZ;;EAEA;;IAEE,kBAAkB;EACpB;AACF","sourcesContent":[".top-movers-tbl-container {\n  width: 100%;\n}\n\n.top-movers-tbl {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.top-movers-tbl-hdr-row {\n  height: 32px;\n  border-bottom: 1px solid var(--border-line);\n}\n\n.top-movers-tbl-cell-row {\n  height: 40px;\n  background-color: var(--row-light);\n}\n\n.top-movers-tbl-cell-row:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.top-movers-tbl thead th:last-child,\n.top-movers-tbl tbody td:last-child {\n  padding-right: 8px;\n}\n\n.top-movers-tbl-cell {\n  box-sizing: border-box;\n  vertical-align: middle;\n}\n\n.top-movers-tbl-hdr-row th {\n  box-sizing: border-box;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n  align-content: start;\n}\n\n.top-movers-tbl-hdr-price,\n.top-movers-tbl-hdr-nct,\n.top-movers-tbl-hdr-pct,\n.top-movers-tbl-hdr-volume,\n.top-movers-tbl-hdr-turnover {\n  text-align: right;\n}\n\n.top-movers-tbl-hdr-ticker,\n.top-movers-tbl-hdr-name,\n.top-movers-tbl-cell-ticker,\n.top-movers-tbl-cell-name {\n  padding-left: 0px;\n  padding-right: 8px;\n}\n\n/* Index */\n.top-movers-tbl-hdr-idx,\n.top-movers-tbl-cell-idx {\n  width: 65px;\n  padding-left: 8px;\n  text-align: center;\n}\n\n.top-movers-tbl-cell-idx {\n  padding: 5px 0px 5px 8px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-subheader);\n}\n\n/* Ticker */\n.top-movers-tbl-hdr-ticker,\n.top-movers-tbl-cell-ticker {\n  width: 80px;\n  white-space: nowrap;\n  text-align: left;\n}\n\n.top-movers-tbl-hdr-today,\n.top-movers-tbl-cell-today {\n  display: none;\n}\n\n.top-movers-tbl-cell-today-container {\n  margin: 0px;\n  padding: 0px;\n  width: 100%;\n  height: 34px;\n}\n\n.top-movers-tbl-cell-today img {\n  height: 100%;\n  width: 100%;\n}\n\n/* Name */\n.top-movers-tbl-hdr-name,\n.rec-tbl-cell-name {\n  text-align: left;\n  white-space: nowrap;\n}\n\n/* Ticker text style — applied whether or not the code is clickable */\n.top-movers-tbl-ticker {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  vertical-align: middle;\n  color: var(--text-ticker);\n}\n\n/* Only when onCallback is provided */\n.top-movers-tbl-ticker-link {\n  cursor: pointer;\n}\n\n.top-movers-tbl-name {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  vertical-align: middle;\n  color: var(--text-instrument);\n}\n\n.top-movers-tbl-cell-name {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n}\n\n.top-movers-tbl-cell-name-container {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.top-movers-tbl-hdr-price,\n.top-movers-tbl-hdr-nct,\n.top-movers-tbl-cell-price,\n.top-movers-tbl-cell-nct {\n  white-space: nowrap;\n  padding-right: 0px;\n}\n\n.top-movers-tbl-cell-price,\n.top-movers-tbl-cell-nct {\n  padding: 7px 0px 7px 16px;\n}\n\n.top-movers-tbl-hdr-pct,\n.top-movers-tbl-cell-pct {\n  width: 25%;\n  padding-right: 8px;\n  text-align: right;\n}\n\n.top-movers-tbl-cell-pct {\n  padding: 7px 8px 7px 16px;\n}\n\n.top-movers-tbl-cell-price {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: right;\n  color: var(--text-primary);\n}\n\n.top-movers-tbl-cell-nct,\n.top-movers-tbl-cell-pct {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: right;\n  color: var(--text-unchg-color);\n}\n\n.top-movers-tbl-cell-nct.positive,\n.top-movers-tbl-cell-pct.positive {\n  color: var(--text-up-color);\n}\n\n.top-movers-tbl-cell-nct.negative,\n.top-movers-tbl-cell-pct.negative {\n  color: var(--text-down-color);\n}\n\n.top-movers-tbl-cell-volume {\n  padding: 5px 0px 5px 16px;\n}\n\n.top-movers-tbl-hdr-volume,\n.top-movers-tbl-cell-volume,\n.top-movers-tbl-hdr-turnover,\n.top-movers-tbl-cell-turnover {\n  text-align: right;\n  font-size: 16px;\n  white-space: nowrap;\n  color: var(--text-primary);\n}\n\n.top-movers-tbl-hdr-code-name {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1e1f2f;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.top-movers-tbl-cell-code-name {\n  padding: 5px 16px 5px 0px;\n  vertical-align: middle;\n}\n\n.top-movers-tbl-cell.top-movers-tbl-cell-code-name {\n  padding-left: 8px;\n}\n\n.top-movers-tbl-code-name-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.top-movers-tbl-code-row,\n.top-movers-tbl-company-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.top-movers-tbl-flag-placeholder {\n  width: 16px;\n}\n\n.top-movers-tbl-company-name {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #1e1f2f;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.top-movers-table-spacer {\n  height: 8px;\n}\n\n@container (min-width: 768px) {\n  .top-movers-tbl thead th:last-child,\n  .top-movers-tbl tbody td:last-child {\n    padding-right: 0px;\n  }\n  .top-movers-tbl-hdr-today,\n  .top-movers-tbl-cell-today {\n    display: table-cell;\n    padding-left: 12px;\n  }\n\n  .top-movers-tbl-hdr-name,\n  .top-movers-tbl-cell-name {\n    width: 25%;\n  }\n\n  .top-movers-tbl-hdr-idx {\n    padding-right: 16px;\n    padding-left: 20px;\n  }\n\n  .top-movers-tbl-hdr-ticker,\n  .top-movers-tbl-cell-ticker,\n  .top-movers-tbl-hdr-name,\n  .top-movers-tbl-cell-name {\n    padding-left: 16px;\n  }\n\n  .top-movers-tbl-hdr-nct,\n  .top-movers-tbl-cell-nct,\n  .top-movers-tbl-hdr-pct,\n  .top-movers-tbl-cell-pct {\n    width: 10%;\n    padding-right: 0px;\n  }\n  .top-movers-tbl tbody td.top-movers-tbl-cell-volume {\n    width: 15%;\n    padding-right: 12px;\n  }\n  .top-movers-tbl thead th.top-movers-tbl-hdr-volume {\n    width: 15%;\n    padding-right: 12px;\n  }\n}\n\n@container (min-width: 1024px) {\n  .top-movers-tbl-hdr-ticker,\n  .top-movers-tbl-hdr-name {\n    padding-left: 16px;\n  }\n  .top-movers-tbl-hdr-idx {\n    padding-left: 24px;\n  }\n  .top-movers-tbl thead th.top-movers-tbl-hdr-turnover,\n  .top-movers-tbl tbody td.top-movers-tbl-cell-turnover {\n    padding-right: 16px;\n  }\n\n  .top-movers-tbl-hdr-nct,\n  .top-movers-tbl-cell-nct,\n  .top-movers-tbl-hdr-pct,\n  .top-movers-tbl-cell-pct {\n    width: unset;\n  }\n\n  .top-movers-tbl thead th.top-movers-tbl-hdr-volume,\n  .top-movers-tbl tbody td.top-movers-tbl-cell-volume,\n  .top-movers-tbl thead th.top-movers-tbl-hdr-turnover,\n  .top-movers-tbl tbody td.top-movers-tbl-cell-turnover {\n    width: 14%;\n  }\n\n  .top-movers-tbl thead th.top-movers-tbl-hdr-volume,\n  .top-movers-tbl tbody td.top-movers-tbl-cell-volume {\n    padding-right: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
